export default "__VITE_ASSET__Dx6AKILt__"